import {FrameworkConfiguration} from 'aurelia-framework';

export function configure(config: FrameworkConfiguration) {
    config.globalResources([
        "./elements/dropdown-checklist",
        "./elements/page-message",
        "./elements/page-alert",
        "./elements/recaptcha",
        "./elements/toggle-badge",
        "./elements/type-ahead",
        "./elements/read-more",
        "./elements/badge",
        "./elements/org-chart/org-chart",
        "./elements/org-chart/org-node",
        "./elements/app-message-bar",
        "./value-converters/phone",
        "./value-converters/currency",
        "./value-converters/number-display",
        "./value-converters/short-date",
        "./value-converters/short-date-time",
        "./value-converters/date-time",
        "./value-converters/upper-case",
        "./value-converters/lower-case",
        "./value-converters/number-only",
        "./value-converters/comma-space",
        "./value-converters/boolean-2-string",
        "./attributes/auto-focus",
        "./attributes/tooltip",
        "./attributes/slide-if",
        "./attributes/security-role",
        "ag-grid-aurelia"
    ]);
}